// extracted by mini-css-extract-plugin
export default {"Paper":"DownloadPdfReportsDropdown_Paper__nP0Nm"};